// Vendors
import { replace } from 'connected-react-router';

// Actions
import * as actions from '../reducers/error/errorActions';
import { openModal } from '../reducers/modal/modalActions';
import { clearLoginState } from '../reducers/login/loginActions';
import { redirectToSignIn } from '../reducers/auth/authActions';

// Selectors
import { selectSignInParamValue } from '../reducers/auth/authSelectors';
import { bodyHasError } from '../lib/validation/serverErrors';

export const ErrorMiddlewareListeners = {
  [actions.SERVER_ERROR]: ({ dispatch }, { payload }) => {
    const body = payload ? payload.body : {};
    const REF =
      bodyHasError(body) && body.errors.ERROR && body.errors.REF
        ? body.errors.REF[0]
        : null;

    const options = payload.options || {};
    const { extraOptions = {} } = options;
    if (bodyHasError(body, { errorCodes: ['MGMW_E_0005', 'MGMW_E_0006'] })) {
      const errorCode = body.errors.ERROR;
      const errorMsg = errorCode
        .filter(code => code.split('|||')[0] === 'MGMW_E_0005')[0]
        .split('|||')[1];
      if (errorMsg && errorMsg.includes('DL/ID is locked'))
        dispatch(openModal('DPS_USER_LOCKOUT_MODAL'));
      else dispatch({ type: actions.ERROR_LOCKOUT, payload });
    } else if (bodyHasError(body, { errorCodes: ['MGMW_EX_4003'] })) {
      const pathArr = window.location.pathname.split('/');
      if (pathArr.includes('dashboard')) {
        return;
      } else {
        const errorCode = body.errors.ERROR;
        dispatch(openModal('ServiceDownModal', { errorCode }));
      }
    } else {
      const pathArr = window.location.pathname.split('/');
      if (
        (payload.response.url.includes('lookup') &&
          pathArr.includes('dashboard')) ||
        payload.response.url.includes('unlink')
      ) {
        return payload;
      }
      dispatch(openModal('ServerErrorModal', { REF, ...extraOptions }));
    }
    return payload;
  },
  [actions.ERROR_LOCKOUT]: ({ dispatch, getState }, action) => {
    const signInParam = selectSignInParamValue(getState());

    dispatch(
      openModal('LockoutModal', {
        onOpen: () => {
          dispatch(clearLoginState());
          return dispatch(
            replace(`/sign-in${signInParam ? `?welcome=${signInParam}` : ''}`)
          );
        },
      })
    );
    return action.payload;
  },
  [actions.ERROR_FORBIDDEN]: ({ dispatch, getState }, action) => {
    const path = getState().router.location.pathname;
    if (path !== '/sign-in') {
      dispatch(clearLoginState());
      dispatch(redirectToSignIn());
    }

    return action.payload;
  },
};

const ErrorMiddleware = store => next => action => {
  if (ErrorMiddlewareListeners[action.type])
    return ErrorMiddlewareListeners[action.type](store, action);
  return next(action);
};

export default ErrorMiddleware;
